var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59.5342,
    height: 59.5342,
    rx: 11.9068,
    fill: "#BAFED2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7912 41.6754C26.0054 41.6754 25.2463 41.3658 24.6867 40.8032L18.7333 34.8498C17.5694 33.6859 17.5694 31.8046 18.7333 30.6407C19.8972 29.4768 21.7784 29.4768 22.9423 30.6407L26.3298 34.0282L36.2214 19.1863C37.1323 17.817 38.9779 17.4479 40.3501 18.3618C41.7164 19.2756 42.0856 21.1212 41.1747 22.4905L29.2678 40.3507C28.7737 41.0919 27.97 41.5742 27.0859 41.6605C26.9847 41.6694 26.8895 41.6754 26.7912 41.6754Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxControl);
export default __webpack_public_path__ + "static/media/checkbox-control.619fcbbd81bdfc60dd4f81c09bb4d1f8.svg";
export { ForwardRef as ReactComponent };